import { ImageFragment } from "../../fragments/image";
import { gql } from "@apollo/client";

export const FIND_USER_BY_ID = gql`
  query findUsersPermissionsUserById($documentId: ID!) {
    usersPermissionsUser(documentId: $documentId) {
      data {
        id
        documentId
        attributes {
          username
          email
          provider
          confirmed
          blocked
          onboardHomeCompleted
          location
          forename
          surname
          confirmationEmailSent
          ageBracket
          gender
          onboardQuestionsCompleted
          isLeadershipWheelTrackingDisabled
          onboardLeadershipWheelCompleted
          # disableSwipeHint
          profile
          createdAt
          school {
            data {
              id
              documentId
              attributes {
                name
                subscription {
                  data {
                    attributes {
                      name
                      knowledgeBase
                      learn
                      search
                      bookmark
                      mission
                      podcast
                      resourceHub
                    }
                  }
                }
              }
            }
          }
          access_control_list {
            data {
              attributes {
                name
                isInstructor
                isMAT
                reportingTools
                manageStaff
              }
            }
          }
          school {
            data {
              id
              documentId
              attributes {
                subscription {
                  data {
                    attributes {
                      name
                      knowledgeBase
                      learn
                      search
                      bookmark
                      mission
                      podcast
                      resourceHub
                    }
                  }
                }
              }
            }
          }
          createdAt
          photo {
            data {
              attributes {
                url
                alternativeText
              }
            }
          }
        }
      }
    }
  }
`;

export const PROFILE_PAGE = gql`
  query profilePage {
    profilePage {
      data {
        attributes {
          welcomeTitle
          profileInfoSection {
            memberSinceTitle
            youLocationTitle
            editYourInfoCta
            saveYourChangesCta
            saveYourChangesSettingsCta
            surnamePlaceholder
            forenamePlaceholder
          }
          profilePasswordSection {
            yourPasswordTitle
            yourCurrentPasswordField
            yourNewPasswordField
            confirmYourPasswordField
            confirmYourChangesCta
          }
          profileNotificationsSection {
            yourNotificationsTitle
            confirmYourChangesCta
          }
          profileSubTraitsSection {
            yourFocusTitle
            whichAreasTitle
            confirmYouChangesCta
          }
          traitTrackingSection {
            title
            btnStopTrackingLabel
            btnStartTrackingLabel
            notRecordedLabel
            notRecordedDescription
            notRecordedIcon {
              data {
                ...ImageFragment
              }
            }
            notTrackingIcon {
              data {
                ...ImageFragment
              }
            }
          }
          statsAndStreaks {
            finishingCardStreak {
              days
              title
            }
            finishingCardMaxStreak {
              days
              title
            }
            finishingCardLeadershipWheel {
              traits
            }
          }
          editProfileButtonLabel
          closeAccountButtonlabel
          confirmAccountClosureTitle
          confirmAccountClosureDescription
        }
      }
    }
  }
  ${ImageFragment}
`;
